import React, { useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { isAuthenticated } from '../utils/auth';
import Loader from '../common/Loader';
import { useUser } from '../../context/UserContext';

const ProtectedRoute = () => {
    const { loading } = useUser();
    const [animationFinished, setAnimationFinished] = useState(false);

    if (!isAuthenticated()) {
        return <Navigate to="/login" replace />;
    }

    // Show loader if still fetching data OR if the animation hasn't finished its 100% cycle
    if (loading || !animationFinished) {
        return (
            <Loader
                fullPage
                isDataReady={!loading}
                onComplete={() => setAnimationFinished(true)}
            />
        );
    }

    return <Outlet />;
};

export default ProtectedRoute;
